<template>
    <div class="col-12 content-container">
        <div class="center">
            <span class="col-12 no-results">
                {{ $t('common.no_results')}}</span>
        </div>
        <div class="center">
            <router-link to="/">
                <span class="col-12 no-results" >
                {{ $t('common.back_to_main')}}</span>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "no-results"
    }
</script>

<style scoped>

</style>